import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionHeading, Reveal } from "@/components/Reveal";
import { FAQS } from "@/data/content";

export const FAQSection = () => {
  return (
    <section id="faq" className="py-16 sm:py-20 lg:py-24" data-testid="faq-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="Questions"
            title="Everything you need to know"
            description="Can't find your answer? The contact form below reaches the director directly."
          />
        </div>

        <Reveal className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-border"
                data-testid="faq-accordion-item"
              >
                <AccordionTrigger
                  data-testid="faq-accordion-trigger"
                  className="text-left text-sm sm:text-base font-medium text-foreground hover:text-primary hover:no-underline transition-colors duration-200 py-5"
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-muted-foreground pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
